import React, { useState, Fragment, useEffect } from "react";
import Layout from "../../components/Layout/Layout";
import { Link } from "react-router-dom";
import { SearchIcon, QuestionMarkCircleIcon } from "@heroicons/react/solid";
import { PlusCircleIcon, DotsHorizontalIcon } from "@heroicons/react/outline";
import { Menu, Transition } from "@headlessui/react";
import fire from "./../../utils/Toastr";
import ThirdPartyServices from "../../services/ThirdParty";
import { HollowDotsSpinner } from "react-epic-spinners";

export default function ThirdPartyOrg() {
  const [thirdParty, setThirdParty] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const listThirdParty = async () => {
      setLoading(true);
      try {
        const response = await ThirdPartyServices.ListThirdPartyUsers();
        setThirdParty(response.data);
      } catch (err) {
        setError("Failed to fetch third-party organizations");
        fire("error", "Failed to fetch third-party organizations");
      } finally {
        setLoading(false);
      }
    };

    listThirdParty();
  }, []);

  return (
    <Layout
      title={"Third-Party Organizations"}
      current={"thirdparty"}
      pageTag="thirdparty"
    >
      <React.Fragment>
        <main>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <div className="px-4 sm:px-6 lg:px-8">
              <div className="sm:flex sm:items-center">
                <div className="sm:flex-auto flex">
                  <div className="flex">
                    <div className="mt-1 relative rounded-md shadow-sm">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <SearchIcon
                          className="h-5 w-5 text-gray-400"
                          aria-hidden="true"
                        />
                      </div>
                      <input
                        type="text"
                        name="user"
                        id="user"
                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                        placeholder="Search users"
                      />
                      <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                        <div className="tooltip">
                          <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                          <span className="tooltiptext">
                            {" "}
                            <p>
                              Search by first name,surname, role name , email
                              address and username
                            </p>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="mt-1 ml-4">
                      <button className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
                        Search
                      </button>
                    </div>
                  </div>
                </div>

                <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                  <Link to="/create/thirdparty">
                    <button
                      type="button"
                      className="inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-2 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
                    >
                      <PlusCircleIcon className="w-4 mr-1.5" />
                      Create ThirdParty Organization
                    </button>
                  </Link>
                </div>
              </div>
              {loading ? (
                <div className="mt-8">
                  {" "}
                  <HollowDotsSpinner color="#4A90E2" />
                </div>
              ) : error ? (
                <div className="mt-8 text-red-500">{error}</div>
              ) : thirdParty.length === 0 ? (
                <div className="mt-8">No data available to show.</div>
              ) : (
                <div className="mt-8 flex ">
                  <div className="-my-2 -mx-4 overflow-x-auto ">
                    <div className="inline-block min-w-full py-2 align-middle mb-20 ">
                      <div className="relative ring-1 ring-black ring-opacity-5 md:rounded-lg">
                        <table className="min-w-full table-fixed divide-y divide-gray-300">
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                className="min-w-[10rem] py-3.5 pl-5 pr-3 italic font-normal text-left text-sm text-gray-400"
                              >
                                Application Name
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                Company Name
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                Company Unique Identifier
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                Address
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                Account Number
                              </th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200 bg-white">
                            {thirdParty.map((third, i) => (
                              <tr key={i} className="bg-gray-50">
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  {third.applicationName}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  {third.companyName}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  {third.companyUniqueIdentifier}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  {third.address}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  {third.accountNumber}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </main>
      </React.Fragment>
    </Layout>
  );
}
